<twaice-fe-breach-history-chart
  [evaluations]="ruleEvaluations$ | async"
  [lookbackDays]="(lookbackDays$ | async) ?? 0"
  [requestedWindow]="requestedWindow$ | async"
  [storageTimezone]="storageTimezone$ | async"
  [isLoading]="(isLoading$ | async) ?? true"
  [isEmpty]="(emptyState$ | async) ?? false"
  [isError]="(errorState$ | async) ?? false"
/>
